<main class="blog-page">
  <div class="blog-content">
    <header class="blog-header">
      <p class="blog-eyebrow">
        <span aria-hidden="true"></span>
        {{ 'Recent Stories' | translate:'Recent Stories' }}
      </p>
      <h1>{{ 'Blog' | translate:'Blog' }}</h1>
      <p class="blog-intro">
        {{ 'Discover insights, updates, and stories from our team' | translate:'Discover insights, updates, and stories from our team' }}
      </p>
    </header>

    <div *ngIf="isLoading" class="blog-status" role="status" aria-live="polite">
      {{ 'Loading posts…' | translate:'Loading posts…' }}
    </div>
    <div *ngIf="!isLoading && error" class="blog-status blog-status--error" role="alert">
      {{ error }}
    </div>
    <div *ngIf="!isLoading && !error && posts.length === 0" class="blog-status">
      {{ 'No posts are available right now. Please check back soon.' | translate:'No posts are available right now. Please check back soon.' }}
    </div>

    <div *ngIf="!isLoading && !error && posts.length > 0" class="blog-grid">
      <article *ngFor="let item of posts" class="blog-post">
        <a [href]="item.link" target="_blank" rel="noopener noreferrer" class="blog-post-image-link"
          [attr.aria-label]="item.title">
          <img
            [src]="item.image || 'https://images.unsplash.com/photo-1486312338219-ce68d2c6f44d?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80'"
            [alt]="item.title"
            class="blog-post-image"
            loading="lazy" />
        </a>

        <div class="blog-post-content">
          <div class="blog-post-meta">
            <time *ngIf="item.dateLabel" [attr.datetime]="item.dateIso">{{ item.dateLabel }}</time>
            <span class="blog-post-category">{{ item.category || 'Technology' }}</span>
          </div>

          <h2 class="blog-post-title">
            <a [href]="item.link" target="_blank" rel="noopener noreferrer">{{ item.title }}</a>
          </h2>
          <p class="blog-post-description">{{ item.description }}</p>

          <div class="blog-post-footer">
            <span class="blog-post-author">
              <span class="blog-post-author-initial" aria-hidden="true">{{ item.authorInitial }}</span>
              <span>{{ item.authorName }}</span>
            </span>
            <a [href]="item.link" target="_blank" rel="noopener noreferrer" class="blog-read-more">
              {{ 'Read article' | translate:'Read article' }}
              <svg viewBox="0 0 20 20" fill="none" aria-hidden="true">
                <path d="M4 10h12m-5-5 5 5-5 5" stroke="currentColor" stroke-width="1.6"
                  stroke-linecap="round" stroke-linejoin="round" />
              </svg>
            </a>
          </div>
        </div>
      </article>
    </div>

    <div *ngIf="totalPosts > 6" class="blog-all-posts">
      <a href="https://medium.com/@badfitech" target="_blank" rel="noopener noreferrer">
        {{ 'View all posts' | translate:'View all posts' }}
        <svg viewBox="0 0 20 20" fill="none" aria-hidden="true">
          <path d="M4 10h12m-5-5 5 5-5 5" stroke="currentColor" stroke-width="1.6"
            stroke-linecap="round" stroke-linejoin="round" />
        </svg>
      </a>
    </div>
  </div>
</main>
